import { leagueFetch } from "@leagueplatform/league-fetch";

export type CodeKind = "procedure" | "diagnosis";
export type CodeResult = { code: string; description: string };

export const searchCodes = async (
  kind: CodeKind,
  query: string,
  signal: AbortSignal
): Promise<CodeResult[]> => {
  const response = await leagueFetch(`/v1/${kind}-code-searches`, {
    method: "POST",
    headers: { "Content-Type": "application/vnd.api+json" },
    signal,
    skipErrorCapture: true,
    body: JSON.stringify({
      data: {
        type: `${kind}-code-search`,
        attributes: {
          query: query.trim(),
        },
      },
    }),
  });
  // Never include the response body or search text in errors/telemetry.
  if (!response.ok) throw new Error("Code search failed");
  const body = await response.json();
  if (
    !Array.isArray(body.data) ||
    !body.data.every(
      (item: { attributes?: Partial<CodeResult> }) =>
        typeof item?.attributes?.code === "string" &&
        typeof item?.attributes?.description === "string"
    )
  ) {
    throw new Error("Invalid code search response");
  }
  return body.data.map((item: { attributes: CodeResult }) => item.attributes);
};
